import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Qubus';

  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: 'smooth'});
  }

  mail()
  {
    window.location.href='mailto:qubus.ai@gmail.com';
  }
}
